import styles from './FilterButton.module.scss';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '@casops/store/hooks';
import { openSidePanel, SidePanel } from '@casops/store/slices/globalSlice';
import { VdsButton, VdsIcon } from '@volt/volt-extended-components-react';
import { useCallback } from 'react';
import { FilterGroup } from '@casops/filters/types';

interface FilterButtonProps {
  filters?: FilterGroup;
  disabled?: boolean;
}

export function FilterButton({ filters, disabled = false }: FilterButtonProps) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isDisabled = disabled || typeof filters === 'undefined';
  const onShowFilterPanel = useCallback(() => {
    if (!isDisabled) {
      dispatch(openSidePanel({ sidePanel: SidePanel.Filters, filters }));
    }
  }, [dispatch, isDisabled, filters]);
  return (
    <VdsButton variant="secondary" onClick={onShowFilterPanel} disabled={isDisabled}>
      {t('Filters')}
      <VdsIcon slot="icon-left" svgIcon="filter" className={styles.filterIcon} />
    </VdsButton>
  );
}

export default FilterButton;
